import {
  Box,
  Button,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import { EXTERNAL_CODE_SYSTEMS } from "config/immunizationConstants";

const ExternalCodesField = ({ value = [], onChange, disabled }) => {
  const rows = Array.isArray(value) ? value : [];

  const update = (index, patch) =>
    onChange(rows.map((row, i) => (i === index ? { ...row, ...patch } : row)));

  const remove = (index) => onChange(rows.filter((_, i) => i !== index));

  const add = () =>
    onChange([...rows, { system: "SNOMED", code: "", display: "" }]);

  return (
    <Box>
      <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
        External Codes
      </Typography>

      {rows.length === 0 && (
        <Typography variant="caption" color="text.secondary">
          No terminology mappings yet.
        </Typography>
      )}

      {rows.map((row, index) => (
        <Box
          key={index}
          sx={{ display: "flex", gap: 1, alignItems: "flex-start", mb: 1 }}
        >
          <TextField
            select
            size="small"
            label="System"
            sx={{ minWidth: 130 }}
            value={row.system || "SNOMED"}
            disabled={disabled}
            onChange={(event) => update(index, { system: event.target.value })}
          >
            {EXTERNAL_CODE_SYSTEMS.map((system) => (
              <MenuItem key={system} value={system}>
                {system}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            size="small"
            label="Code"
            required
            value={row.code || ""}
            disabled={disabled}
            onChange={(event) => update(index, { code: event.target.value })}
          />

          <TextField
            size="small"
            label="Display"
            fullWidth
            value={row.display || ""}
            disabled={disabled}
            onChange={(event) => update(index, { display: event.target.value })}
          />

          <IconButton onClick={() => remove(index)} disabled={disabled}>
            <DeleteOutlineIcon fontSize="small" color="error" />
          </IconButton>
        </Box>
      ))}

      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={add}
        disabled={disabled}
      >
        Add code
      </Button>
    </Box>
  );
};

export default ExternalCodesField;
